import React, { useState, useEffect } from 'react'

import Cookies from 'js-cookie'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { Contact } from './Include'
import './Layout.css'
import UnProtectedView from '../UnprotectedView'

const Layout = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  // Function to check if a path is active
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  // Handle scroll event to change navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    // Prevent body scrolling when menu is open
    document.body.style.overflow = mobileMenuOpen ? 'auto' : 'hidden';
  };
  
  // Legacy function for backward compatibility
  const openLandingSidemenu = () => {
    var element = document.getElementById('body');
    element?.classList.toggle("landing-sidemenu-open");
  }


 let stop:any = Date.now();
   const clearCookies=()=>{
     Cookies.remove('app_tcpcdk')
      Cookies.remove('app_tcscdk')	
   localStorage.setItem('_spexpt', stop)
   localStorage.setItem('_spbexpt', stop)
   }
   
   useEffect(()=>{
     clearCookies()
   }, [])


  return (
    <>
      <div className="page landing-page"> 
        <div className="landing-layout"> 
          <div className="prevent-top"></div>
          
          {/* Side menu for mobile */}
          <div className="sidemenu-landing"> 
            <ul className="nav flex-column flex-nowrap mt-3 pb-3 border-bottom"> 
              <li className="nav-item">
                <a href="/" className={`nav-link nav-scroll ${isActive('/') ? 'active' : ''}`}><i className='fa fa-print'></i> Home</a>
              </li> 
              <li className="nav-item">
                <a href="/verify-payment" className={`nav-link nav-scroll ${isActive('/verify-payment') ? 'active' : ''}`}><i className='fa fa-credit-card'></i> Verify Payment</a>
              </li>
              <li className="nav-item">
                <a href="/view-skills" className={`nav-link nav-scroll ${isActive('/view-skills') ? 'active' : ''}`}><i className='fa fa-tools'></i> View Skills</a>
              </li>

              <li className="nav-item">
                <a href="/exhibition" className={`nav-link nav-scroll ${isActive('/exhibition') ? 'active' : ''}`}><i className='fa fa-envelope'></i> Exhibitions</a>
              </li>

{/*  service menu */}
              <li className="nav-item">
                <a href="https://edc.nsuk.edu.ng/" target='_blank' className="nav-link nav-scroll"><i className='fa fa-info-circle'></i> About Us</a>
              </li>
             
              <li className="nav-item">
                <a href="/login" className={`nav-link nav-scroll ${isActive('/login') ? 'active' : ''}`}><i className='fa fa-sign-in'></i> Login</a>
              </li> 
              <li className="nav-item">
                <a href="/register" className={`nav-link nav-scroll ${isActive('/register') ? 'active' : ''}`}><i className='fa fa-user-plus'></i> Create Account</a>
              </li>
            </ul> 
          </div>
          
          {/* Main content area */}
          <div className="landing-page-content"> 

            {/* Topbar area */}
            <section className="banner-section top" id="home"> 
              <div className="banner-section-content"> 
                {/* Modern Topbar Navigation */}
                <nav className={`modern-navbar navbar navbar-expand-lg ${scrolled ? 'scrolled' : ''}`}>
                  <div className="container">
                    {/* Logo */}
                    <Link className="navbar-brand" to="/">
                      <img src="/images/edc.png" alt="EDC Logo" />
                    </Link>
                    
                    {/* Mobile menu toggle */}
                    <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                      <i className="ri-menu-line fs-24"></i>
                    </button>
                    
                    {/* Desktop menu */}
                    <div className="collapse navbar-collapse desktop-menu">
                      <ul className="navbar-nav mx-auto">
                        <li className="nav-item">
                          <Link className={`nav-link ${isActive('/') ? 'active' : ''}`} to="/">
                            <i className="ri-home-line nav-icon"></i> Home
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className={`nav-link ${isActive('/verify-payment') ? 'active' : ''}`} to="/verify-payment">
                            <i className="ri-secure-payment-line nav-icon"></i> Verify Payment
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className={`nav-link ${isActive('/view-skills') ? 'active' : ''}`} to="/view-skills">
                            <i className="ri-tools-line nav-icon"></i> View Skills
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className={`nav-link ${isActive('/exhibition') ? 'active' : ''}`} to="/exhibition">
                            <i className="ri-gallery-line nav-icon"></i> Exhibitions
                          </Link>
                        </li>

                       {/*  service menu */}
                        <li className="nav-item">
                          <a className="nav-link" href="https://edc.nsuk.edu.ng/" target="_blank">
                            <i className="ri-information-line nav-icon"></i> About Us
                          </a>
                        </li>
                      </ul>
                      
                      {/* Auth buttons */}
                      <div className="auth-buttons">
                        <Link to="/login" className={`btn btn-login ${isActive('/login') ? 'active' : ''}`}>
                          <i className="ri-login-box-line me-1"></i> Login
                        </Link>
                        <Link to="/register" className={`btn btn-register ${isActive('/register') ? 'active' : ''}`}>
                          <i className="ri-user-add-line me-1"></i> Register
                        </Link>
                      </div>
                    </div>
                    
                    {/* Mobile menu */}
                    <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
                      <div className="mobile-menu-header">
                        <img src="/images/edc.png" alt="EDC Logo" height="40" />
                        <button className="mobile-menu-close" onClick={toggleMobileMenu}>
                          <i className="ri-close-line"></i>
                        </button>
                      </div>
                      <div className="mobile-menu-body">
                        <ul className="nav flex-column">
                          <li className="nav-item">
                            <Link className={`nav-link ${isActive('/') ? 'active' : ''}`} to="/">
                              <i className="ri-home-line nav-icon"></i> Home
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${isActive('/verify-payment') ? 'active' : ''}`} to="/verify-payment">
                              <i className="ri-secure-payment-line nav-icon"></i> Verify Payment
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${isActive('/view-skills') ? 'active' : ''}`} to="/view-skills">
                              <i className="ri-tools-line nav-icon"></i> View Skills
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${isActive('/exhibition') ? 'active' : ''}`} to="/exhibition">
                              <i className="ri-gallery-line nav-icon"></i> Exhibitions
                            </Link>
                          </li>
                          
                          <li className="nav-item">
                            <a className="nav-link" href="https://edc.nsuk.edu.ng/" target="_blank">
                              <i className="ri-information-line nav-icon"></i> About Us
                            </a>
                          </li>
                        </ul>
                        <div className="mobile-auth-buttons">
                          <Link to="/login" className={`btn btn-login w-100 ${isActive('/login') ? 'active' : ''}`}>
                            <i className="ri-login-box-line me-1"></i> Login
                          </Link>
                          <Link to="/register" className={`btn btn-register w-100 ${isActive('/register') ? 'active' : ''}`}>
                            <i className="ri-user-add-line me-1"></i> Register
                          </Link>
                        </div>
                      </div>
                    </div>
                    
                    {/* Mobile menu overlay */}
                    <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}></div>
                  </div>
                </nav>
              </div>
            </section>
            
            {/* Main content - Renders child routes */}
      
<UnProtectedView/>


          </div>
        </div>
        
        {/* Footer Area */}
        <div className="footer">
          <div className="footer-content container flex flex-row justify-between">
            <div className="footer-section about">
              <h3>About EDC</h3>
              <p>The Entrepreneurship Development Center (EDC) at NSUK is dedicated to fostering entrepreneurial skills and innovation among students, preparing them for successful careers and business ventures.</p>
              <div className="social-links">
                <a href="#" className="social-icon"><i className="fa fa-facebook"></i></a>
                <a href="#" className="social-icon"><i className="fa fa-twitter"></i></a>
                <a href="#" className="social-icon"><i className="fa fa-instagram"></i></a>
                <a href="#" className="social-icon"><i className="fa fa-linkedin"></i></a>
              </div>
            </div>

            <div className="footer-section quick-links">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/"><i className="fa fa-angle-right"></i> Home</Link></li>
                <li><Link to="/verify-payment"><i className="fa fa-angle-right"></i> Verify Payment</Link></li>
                <li><Link to="/view-skills"><i className="fa fa-angle-right"></i> View Skills</Link></li>
                <li><a href="https://edc.nsuk.edu.ng" target="_blank"><i className="fa fa-angle-right"></i> About Us</a></li>
                <li><Link to="/register"><i className="fa fa-angle-right"></i> Register</Link></li>
              </ul>
            </div>

            <div className="footer-section contact-form">
              <h3>Contact Us</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fa fa-map-marker"></i>
                  <span>{Contact.address}</span>
                </div>
                <div className="contact-item">
                  <i className="fa fa-phone"></i>
                  <span>{Contact.telephone}</span>
                </div>
                <div className="contact-item">
                  <i className="fa fa-envelope"></i>
                  <span>{Contact.email}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="container">
              <div className="copyright text-center">
                Copyright © <span id="year">2024</span> <a href="#">ENTREPRENEURSHIP DEVELOPMENT CENTER, NSUK</a>. Developed by <a href="https://deepsocket.com" target="_blank">Deep Socket</a>. All rights reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout